import { Box } from '@mui/material';
import Image from 'next/image';

export interface NavigationIcon {
  src?: string;
  activeSrc?: string;
  alt?: string;
  Icon?: React.ComponentType;
}

const IconRenderer: React.FC<{
  icon?: NavigationIcon;
  active?: boolean;
  size?: number;
}> = ({ icon, active = false, size = 24 }) => {
  if (!icon) return null;

  if (icon.Icon) {
    const IconComponent = icon.Icon;

    return (
      <Box
        component='span'
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: size,
          '& svg': {
            fontSize: 'inherit',
            width: '1em',
            height: '1em',
          },
        }}
      >
        <IconComponent />
      </Box>
    );
  }

  if (icon.src) {
    const iconSrc = active && icon.activeSrc ? icon.activeSrc : icon.src;
    return (
      <Image
        src={iconSrc}
        alt=''
        aria-hidden
        width={size}
        height={size}
        style={{ flexShrink: 0 }}
      />
    );
  }

  return null;
};

export default IconRenderer;
